import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Radio, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { GridGroup } from '../../../models';

export function NewGridPage(props: { onSaved: () => void; gridGroups?: GridGroup[] }) {
  const [loading, setLoading] = useState(false);
  const [parentOptions, setParentOptions] = useState<any[]>();

  useEffect(() => {
    setParentOptions(
      props.gridGroups?.map(g => ({
        value: g.id,
        label: g.name,
      })),
    );
  }, [props.gridGroups]);

  const onFinish = (values: any) => {
    setLoading(true);

    const body = { ...values };

    apiClient
      .post('grids', body)
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} name="basic" onFinish={onFinish}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            pattern: /^[a-zA-Z0-9ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/,
            message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir',
          },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Açıklama"
        name="description"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 400, message: 'En fazla 400 karakter' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item label="Veri seti grubu" name="groupId">
        <Select>
          {parentOptions?.map(o => (
            <Select.Option value={o.value} key={o.value}>
              {o.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Önem seviyesi" name="priority" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Radio.Group>
          <Radio.Button value={1}>!</Radio.Button>
          <Radio.Button value={2}>!!</Radio.Button>
          <Radio.Button value={3}>!!!</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="allowRecordWithErrors" valuePropName="checked">
        <Checkbox>Kural hatalı kayıt oluşturulabilsin</Checkbox>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
